<template>
    <form :name="'tx_editor_form' + editorid" :id="'tx_editor_form' + editorid" action="http://posttestserver.com/post.php" method="post" accept-charset="utf-8">
        <div :id="'tx_trex_container' + editorid" class="tx-editor-container">
            <!-- 사이드바 -->
            <div :id="'tx_sidebar' + editorid" class="tx-sidebar">
                <div class="tx-sidebar-boundary">
                    <!-- 사이드바 / 첨부 -->
                    <ul class="tx-bar tx-bar-left tx-nav-attach">
                        <li class="tx-list">
                            <fileupload ref="cnPicFile"
                                        :formse="'cusBtn'"
                                        :filelist="cnFileList"
                                        :maxcnt="1"
                                        :maxsize="10"
                                        :extsns="'jpg,png,jpeg,bmp,gif'"
                                        :func="cnImageFileUpCallback"
                                        :setstorge="setstorge"
                                        :setbasepath="setbasepath">
                            </fileupload>
                            <div unselectable="on" @click="handleFileUploadClick" class="tx-image tx-btn-trans">
                                <a href="javascript:;" title="사진" class="tx-text">사진</a>
                            </div>
                        </li>
                        <!-- 이미지 첨부 버튼 끝 -->
                        <li class="tx-list" style='display:none'>
                            <div unselectable="on" :id="'tx_file' + editorid" class="tx-file tx-btn-trans">
                                <a href="javascript:;" title="파일" class="tx-text">파일</a>
                            </div>
                        </li>
                    </ul>
                    <!-- 사이드바 / 우측영역 -->
                    <ul class="tx-bar tx-bar-right tx-nav-opt">
                        <li class="tx-list">
                            <div unselectable="on" class="tx-switchtoggle" :id="'tx_switchertoggle' + editorid">
                                <a href="javascript:;" title="에디터 타입">에디터</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- 툴바 - 기본 시작 -->
            <!--
            @decsription
            툴바 버튼의 그룹핑의 변경이 필요할 때는 위치(왼쪽, 가운데, 오른쪽) 에 따라 <li> 아래의 <div>의 클래스명을 변경하면 된다.
            tx-btn-lbg: 왼쪽, tx-btn-bg: 가운데, tx-btn-rbg: 오른쪽, tx-btn-lrbg: 독립적인 그룹

            드롭다운 버튼의 크기를 변경하고자 할 경우에는 넓이에 따라 <li> 아래의 <div>의 클래스명을 변경하면 된다.
            tx-slt-70bg, tx-slt-59bg, tx-slt-42bg, tx-btn-43lrbg, tx-btn-52lrbg, tx-btn-57lrbg, tx-btn-71lrbg
            tx-btn-48lbg, tx-btn-48rbg, tx-btn-30lrbg, tx-btn-46lrbg, tx-btn-67lrbg, tx-btn-49lbg, tx-btn-58bg, tx-btn-46bg, tx-btn-49rbg
            -->
            <div :id="'tx_toolbar_basic' + editorid" class="tx-toolbar tx-toolbar-basic">
                <div class="tx-toolbar-boundary">
                    <ul class="tx-bar tx-bar-left">
                        <li class="tx-list">
                            <div :id="'tx_fontfamily' + editorid" unselectable="on" class="tx-slt-70bg tx-fontfamily">
                                <a href="javascript:;" title="글꼴">굴림</a>
                            </div>
                            <div :id="'tx_fontfamily_menu' + editorid" class="tx-fontfamily-menu tx-menu" unselectable="on"></div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left">
                        <li class="tx-list">
                            <div unselectable="on" class="tx-slt-42bg tx-fontsize" :id="'tx_fontsize' + editorid">
                                <a href="javascript:;" title="글자크기">9pt</a>
                            </div>
                            <div :id="'tx_fontsize_menu' + editorid" class="tx-fontsize-menu tx-menu" unselectable="on"></div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left tx-group-font">
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-lbg 	tx-bold" :id="'tx_bold' + editorid">
                                <a href="javascript:;" class="tx-icon" title="굵게 (Ctrl+B)">굵게</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-underline" :id="'tx_underline' + editorid">
                                <a href="javascript:;" class="tx-icon" title="밑줄 (Ctrl+U)">밑줄</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-italic" :id="'tx_italic' + editorid">
                                <a href="javascript:;" class="tx-icon" title="기울임 (Ctrl+I)">기울임</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-strike" :id="'tx_strike' + editorid">
                                <a href="javascript:;" class="tx-icon" title="취소선 (Ctrl+D)">취소선</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-slt-tbg 	tx-forecolor" :id="'tx_forecolor' + editorid">
                                <a href="javascript:;" class="tx-icon" title="글자색">글자색</a>
                                <a href="javascript:;" class="tx-arrow" title="글자색 선택">글자색 선택</a>
                            </div>
                            <div :id="'tx_forecolor_menu' + editorid" class="tx-menu tx-forecolor-menu tx-colorpallete" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-slt-brbg 	tx-backcolor" :id="'tx_backcolor' + editorid">
                                <a href="javascript:;" class="tx-icon" title="글자 배경색">글자 배경색</a>
                                <a href="javascript:;" class="tx-arrow" title="글자 배경색 선택">글자 배경색 선택</a>
                            </div>
                            <div :id="'tx_backcolor_menu' + editorid" class="tx-menu tx-backcolor-menu tx-colorpallete" unselectable="on"></div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left tx-group-align">
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-lbg 	tx-alignleft" :id="'tx_alignleft' + editorid">
                                <a href="javascript:;" class="tx-icon" title="왼쪽정렬 (Ctrl+,)">왼쪽정렬</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-aligncenter" :id="'tx_aligncenter' + editorid">
                                <a href="javascript:;" class="tx-icon" title="가운데정렬 (Ctrl+.)">가운데정렬</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-alignright" :id="'tx_alignright' + editorid">
                                <a href="javascript:;" class="tx-icon" title="오른쪽정렬 (Ctrl+/)">오른쪽정렬</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-rbg 	tx-alignfull" :id="'tx_alignfull' + editorid">
                                <a href="javascript:;" class="tx-icon" title="양쪽정렬">양쪽정렬</a>
                            </div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left tx-group-tab">
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-lbg 	tx-indent" :id="'tx_indent' + editorid">
                                <a href="javascript:;" title="들여쓰기 (Tab)" class="tx-icon">들여쓰기</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-rbg 	tx-outdent" :id="'tx_outdent' + editorid">
                                <a href="javascript:;" title="내어쓰기 (Shift+Tab)" class="tx-icon">내어쓰기</a>
                            </div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left tx-group-list">
                        <li class="tx-list">
                            <div unselectable="on" class="tx-slt-31lbg tx-lineheight" :id="'tx_lineheight' + editorid">
                                <a href="javascript:;" class="tx-icon" title="줄간격">줄간격</a>
                                <a href="javascript:;" class="tx-arrow" title="줄간격">줄간격 선택</a>
                            </div>
                            <div :id="'tx_lineheight_menu' + editorid" class="tx-lineheight-menu tx-menu" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="tx-slt-31rbg tx-styledlist" :id="'tx_styledlist' + editorid">
                                <a href="javascript:;" class="tx-icon" title="리스트">리스트</a>
                                <a href="javascript:;" class="tx-arrow" title="리스트">리스트 선택</a>
                            </div>
                            <div :id="'tx_styledlist_menu' + editorid" class="tx-styledlist-menu tx-menu" unselectable="on"></div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left tx-group-etc">
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-lbg 	tx-emoticon" :id="'tx_emoticon' + editorid">
                                <a href="javascript:;" class="tx-icon" title="이모티콘">이모티콘</a>
                            </div>
                            <div :id="'tx_emoticon_menu' + editorid" class="tx-emoticon-menu tx-menu" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-link" :id="'tx_link' + editorid">
                                <a href="javascript:;" class="tx-icon" title="링크 (Ctrl+K)">링크</a>
                            </div>
                            <div :id="'tx_link_menu' + editorid" class="tx-link-menu tx-menu"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-specialchar" :id="'tx_specialchar' + editorid">
                                <a href="javascript:;" class="tx-icon" title="특수문자">특수문자</a>
                            </div>
                            <div :id="'tx_specialchar_menu' + editorid" class="tx-specialchar-menu tx-menu"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-table" :id="'tx_table' + editorid">
                                <a href="javascript:;" class="tx-icon" title="표만들기">표만들기</a>
                            </div>
                            <div :id="'tx_table_menu' + editorid" class="tx-table-menu tx-menu" unselectable="on">
                                <div class="tx-menu-inner">
                                    <div class="tx-menu-preview"></div>
                                    <div class="tx-menu-rowcol"></div>
                                    <div class="tx-menu-deco"></div>
                                    <div class="tx-menu-enter"></div>
                                </div>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-rbg 	tx-horizontalrule" :id="'tx_horizontalrule' + editorid">
                                <a href="javascript:;" class="tx-icon" title="구분선">구분선</a>
                            </div>
                            <div :id="'tx_horizontalrule_menu' + editorid" class="tx-horizontalrule-menu tx-menu" unselectable="on"></div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left">
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-lbg 	tx-richtextbox" :id="'tx_richtextbox' + editorid">
                                <a href="javascript:;" class="tx-icon" title="글상자">글상자</a>
                            </div>
                            <div :id="'tx_richtextbox_menu' + editorid" class="tx-richtextbox-menu tx-menu">
                                <div class="tx-menu-header">
                                    <div class="tx-menu-preview-area">
                                        <div class="tx-menu-preview"></div>
                                    </div>
                                    <div class="tx-menu-switch">
                                        <div class="tx-menu-simple tx-selected">
                                            <a><span>간단 선택</span></a>
                                        </div>
                                        <div class="tx-menu-advanced">
                                            <a><span>직접 선택</span></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="tx-menu-inner"></div>
                                <div class="tx-menu-footer">
                                    <img class="tx-menu-confirm" src="../../../../public/module/daumeditor/images/icon/editor/btn_confirm.gif?rv=1.0.1" alt="" />
                                    <img class="tx-menu-cancel" hspace="3" src="../../../../public/module/daumeditor/images/icon/editor/btn_cancel.gif?rv=1.0.1" alt="" />
                                </div>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-quote" :id="'tx_quote' + editorid">
                                <a href="javascript:;" class="tx-icon" title="인용구 (Ctrl+Q)">인용구</a>
                            </div>
                            <div :id="'tx_quote_menu' + editorid" class="tx-quote-menu tx-menu" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-bg 	tx-background" :id="'tx_background' + editorid">
                                <a href="javascript:;" class="tx-icon" title="배경색">배경색</a>
                            </div>
                            <div :id="'tx_background_menu' + editorid" class="tx-menu tx-background-menu tx-colorpallete" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-rbg 	tx-dictionary" :id="'tx_dictionary' + editorid">
                                <a href="javascript:;" class="tx-icon" title="사전">사전</a>
                            </div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left tx-group-undo">
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-lbg 	tx-undo" :id="'tx_undo' + editorid">
                                <a href="javascript:;" class="tx-icon" title="실행취소 (Ctrl+Z)">실행취소</a>
                            </div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="		 tx-btn-rbg 	tx-redo" :id="'tx_redo' + editorid">
                                <a href="javascript:;" class="tx-icon" title="다시실행 (Ctrl+Y)">다시실행</a>
                            </div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-right">
                        <li class="tx-list">
                            <div unselectable="on" class="tx-btn-nlrbg tx-advanced" :id="'tx_advanced' + editorid">
                                <a href="javascript:;" class="tx-icon" title="툴바 더보기">툴바 더보기</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 툴바 - 기본 끝 -->
            <!-- 툴바 - 더보기 시작 -->
            <div :id="'tx_toolbar_advanced' + editorid" class="tx-toolbar tx-toolbar-advanced">
                <div class="tx-toolbar-boundary">
                    <ul class="tx-bar tx-bar-left">
                        <li class="tx-list">
                            <div class="tx-tableedit-title"></div>
                        </li>
                    </ul>

                    <ul class="tx-bar tx-bar-left tx-group-align">
                        <li class="tx-list">
                            <div unselectable="on" class="tx-btn-lbg tx-mergecells" :id="'tx_mergecells' + editorid">
                                <a href="javascript:;" class="tx-icon2" title="병합">병합</a>
                            </div>
                            <div :id="'tx_mergecells_menu' + editorid" class="tx-mergecells-menu tx-menu" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="tx-btn-bg tx-insertcells" :id="'tx_insertcells' + editorid">
                                <a href="javascript:;" class="tx-icon2" title="삽입">삽입</a>
                            </div>
                            <div :id="'tx_insertcells_menu' + editorid" class="tx-insertcells-menu tx-menu" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div unselectable="on" class="tx-btn-rbg tx-deletecells" :id="'tx_deletecells' + editorid">
                                <a href="javascript:;" class="tx-icon2" title="삭제">삭제</a>
                            </div>
                            <div :id="'tx_deletecells_menu' + editorid" class="tx-deletecells-menu tx-menu" unselectable="on"></div>
                        </li>
                    </ul>

                    <ul class="tx-bar tx-bar-left tx-group-align">
                        <li class="tx-list">
                            <div :id="'tx_cellslinepreview' + editorid" unselectable="on" class="tx-slt-70lbg tx-cellslinepreview">
                                <a href="javascript:;" title="선 미리보기"></a>
                            </div>
                            <div :id="'tx_cellslinepreview_menu' + editorid" class="tx-cellslinepreview-menu tx-menu" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div :id="'tx_cellslinecolor' + editorid" unselectable="on" class="tx-slt-tbg tx-cellslinecolor">
                                <a href="javascript:;" class="tx-icon2" title="선색">선색</a>
                                <div class="tx-colorpallete" unselectable="on"></div>
                            </div>
                            <div :id="'tx_cellslinecolor_menu' + editorid" class="tx-cellslinecolor-menu tx-menu tx-colorpallete" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div :id="'tx_cellslineheight' + editorid" unselectable="on" class="tx-btn-bg tx-cellslineheight">
                                <a href="javascript:;" class="tx-icon2" title="두께">두께</a>
                            </div>
                            <div :id="'tx_cellslineheight_menu' + editorid" class="tx-cellslineheight-menu tx-menu" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div :id="'tx_cellslinestyle' + editorid" unselectable="on" class="tx-btn-bg tx-cellslinestyle">
                                <a href="javascript:;" class="tx-icon2" title="스타일">스타일</a>
                            </div>
                            <div :id="'tx_cellslinestyle_menu' + editorid" class="tx-cellslinestyle-menu tx-menu" unselectable="on"></div>
                        </li>
                        <li class="tx-list">
                            <div :id="'tx_cellsoutline' + editorid" unselectable="on" class="tx-btn-rbg tx-cellsoutline">
                                <a href="javascript:;" class="tx-icon2" title="테두리">테두리</a>
                            </div>
                            <div :id="'tx_cellsoutline_menu' + editorid" class="tx-cellsoutline-menu tx-menu" unselectable="on"></div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left">
                        <li class="tx-list">
                            <div :id="'tx_tablebackcolor' + editorid" unselectable="on" class="tx-btn-lrbg tx-tablebackcolor" style="background-color:#9aa5ea;">
                                <a href="javascript:;" class="tx-icon2" title="테이블 배경색">테이블 배경색</a>
                            </div>
                            <div :id="'tx_tablebackcolor_menu' + editorid" class="tx-tablebackcolor-menu tx-menu tx-colorpallete" unselectable="on"></div>
                        </li>
                    </ul>
                    <ul class="tx-bar tx-bar-left">
                        <li class="tx-list">
                            <div :id="'tx_tabletemplate' + editorid" unselectable="on" class="tx-btn-lrbg tx-tabletemplate">
                                <a href="javascript:;" class="tx-icon2" title="테이블 서식">테이블 서식</a>
                            </div>
                            <div :id="'tx_tabletemplate_menu' + editorid" class="tx-tabletemplate-menu tx-menu tx-colorpallete" unselectable="on"></div>
                        </li>
                    </ul>

                </div>
            </div>
            <!-- 툴바 - 더보기 끝 -->
            <!-- 편집영역 시작 -->
            <!-- 에디터 Start -->
            <div :id="'tx_canvas' + editorid" class="tx-canvas">
                <div :id="'tx_loading' + editorid" class="tx-loading">
                    <div>
                        <img src="../../../../public/module/daumeditor/images/icon/editor/loading2.png" width="113" height="21" align="absmiddle" />
                    </div>
                </div>
                <div :id="'tx_canvas_wysiwyg_holder' + editorid" class="tx-holder" style="display:block;">
                    <iframe :id="'tx_canvas_wysiwyg' + editorid" name="tx_canvas_wysiwyg" allowtransparency="true" frameborder="0"></iframe>
                </div>
                <div class="tx-source-deco">
                    <div :id="'tx_canvas_source_holder' + editorid" class="tx-holder">
                        <textarea :id="'tx_canvas_source' + editorid" rows="30" cols="30"></textarea>
                    </div>
                </div>
                <div :id="'tx_canvas_text_holder' + editorid" class="tx-holder">
                    <textarea :id="'tx_canvas_text' + editorid" rows="30" cols="30"></textarea>
                </div>
            </div>
            <!-- 높이조절 Start -->
            <div :id="'tx_resizer' + editorid" class="tx-resize-bar" style="height: 10px">
                <div class="tx-resize-bar-bg"></div>
            </div>

            <!-- 편집영역 끝 -->
            <!-- 첨부박스 시작 -->
            <!-- 파일첨부박스 Start -->
            <div :id="'tx_attach_div' + editorid" class="tx-attach-div">
                <div :id="'tx_attach_txt' + editorid" class="tx-attach-txt">파일 첨부</div>
                <div :id="'tx_attach_box' + editorid" class="tx-attach-box">
                    <div class="tx-attach-box-inner">
                        <div :id="'tx_attach_preview' + editorid" class="tx-attach-preview">
                            <p></p>
                            <img src="../../../../public/module/daumeditor/images/icon/editor/pn_preview.gif" width="147" height="108" unselectable="on" />
                        </div>
                        <div class="tx-attach-main">
                            <div :id="'tx_upload_progress' + editorid" class="tx-upload-progress">
                                <div>0%</div>
                                <p>파일을 업로드하는 중입니다.</p>
                            </div>
                            <ul class="tx-attach-top">
                                <li :id="'tx_attach_delete' + editorid" class="tx-attach-delete">
                                    <a>전체삭제</a>
                                </li>
                                <li :id="'tx_attach_size' + editorid" class="tx-attach-size">
                                    파일:
                                    <span :id="'tx_attach_up_size' + editorid" class="tx-attach-size-up"></span>/
                                    <span :id="'tx_attach_max_size' + editorid"></span>
                                </li>
                                <li :id="'tx_attach_tools' + editorid" class="tx-attach-tools">
                                </li>
                            </ul>
                            <ul :id="'tx_attach_list' + editorid" class="tx-attach-list"></ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 첨부박스 끝 -->
        </div>
        <!-- 에디터 컨테이너 끝 -->
    </form>
</template>

<script>

    export default {
        name: "editor",
        props: ["editorid","cn","setstorge","setbasepath","cnimgtagfunc"],
        data : function(){
            return {
                cnFileList : new Array()
            }
        },
        methods: {
            handleFileUploadClick: function(){
                this.$refs.cnPicFile.handleFileUploadClick();
            },
            cnImageFileUpCallback: function(){
                if(this.cnFileList.length > 0){
                    var fileInfo    = this.cnFileList[0];

                    if(typeof this.cnimgtagfunc != "undefined"){
                        window.Editor.getCanvas().pasteContent(this.cnimgtagfunc(fileInfo,"tx_trex_container" + this.editorid), true);
                    }


                }
            },
            setConfig : function(){
                var _this = this;

                window.EditorJSLoader.ready(function(Editor) {
                    var EditorConfig = {
                        /* 런타임 시 리소스들을 로딩할 때 필요한 부분으로, 경로가 변경되면 이 부분 수정이 필요. ex) http://xxx.xxx.com */
                        txHost: '',
                        /* 런타임 시 리소스들을 로딩할 때 필요한 부분으로, 경로가 변경되면 이 부분 수정이 필요. ex) /xxx/xxx/ */
                        txPath: '/frontend/module/daumeditor/',
                        /* 수정필요없음. */
                        txService: 'sample',
                        /* 수정필요없음. 프로젝트가 여러개일 경우만 수정한다. */
                        txProject: 'sample',
                        /* 대부분의 경우에 빈문자열 */
                        initializedId: "",
                        /* 등록하기 위한 Form 이름 */
                        form: "viewForm",
                        /*에디터에 사용되는 이미지 디렉터리, 필요에 따라 수정한다. */
                        txIconPath: "/frontend/module/daumeditor/images/icon/editor/",
                        /*본문에 사용되는 이미지 디렉터리, 서비스에서 사용할 때는 완성된 컨텐츠로 배포되기 위해 절대경로로 수정한다. */
                        txDecoPath: "/frontend/module/daumeditor/images/deco/contents/",
                        canvas: {
                            styles: {
                                color: "#000000",
                                fontFamily: "굴림",
                                fontSize: "10pt",
                                backgroundColor: "#fff",
                                lineHeight: "1.5",
                                padding: "8px",
                            },
                            showGuideArea: false
                        },
                        events: {
                            preventUnload: false
                        },

                        size: {
                            contentHeight: 100
                        },


                    };

                    EditorConfig.initializedId = _this.editorid;
                    EditorConfig.form = "tx_editor_form" + EditorConfig.initializedId;

                    /* 에디터를 둘러싸고 있는 레이어 이름(에디터 컨테이너) */
                    EditorConfig.wrapper = "tx_trex_container"+ EditorConfig.initializedId;
                    /*EditorConfig.sidebar = {
                        attacher : {
                            image : {
                                features : {
                                    left : 250,
                                    top : 65,
                                    width : 400,
                                    height : 200,
                                    scrollbars : 0
                                }, //팝업창 사이즈
                                objattr:{width:600},
                                popPageUrl : '/cmmn/editorImg.on?imgresize=N&editorid='+ EditorConfig.initializedId, //팝업창 주소
                            }
                        },
                        attachbox : {
                            show : true,
                            confirmForDeleteAll : true
                        },
                        capacity : {
                            maximum : 20 * 1024 * 1024 * 1024//최대 첨부 용량 (20MB)
                        }
                    };*/

                    new Editor(EditorConfig);

                    Editor.switchEditor(EditorConfig.initializedId);
                    Editor.modify({"content" : _this.cn});
                });
            }
        },
        mounted:function(){
            this.setConfig();
        }
    }
</script>

<style scoped>

</style>